import { useMemo, useState } from "react";
import type { Movie } from "@/types/movie";

interface EpisodeListProps {
  movie: Movie;
}

const descPool = [
  "本集剧情进入关键转折，主角面临艰难抉择，暗线逐渐浮出水面，气氛紧张。",
  "随着新角色登场，原本平静的局面被打破，几条线索开始交汇，悬念升级。",
  "这一集节奏明快，冲突集中爆发，人物关系发生微妙变化，看点十足。",
  "回忆与当下交错展开，补全了此前埋下的伏笔，情感层次更加饱满动人。",
  "团队面临前所未有的困境，众人各怀心思却又不得不并肩前行，张力十足。",
  "在轻松幽默的日常背后，隐藏着推动主线的关键信息，笑点与机关并存。",
];

export default function EpisodeList({ movie }: EpisodeListProps) {
  const count = movie.episodeCount ?? 0;
  const [selected, setSelected] = useState(0);

  const episodes = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        index: i + 1,
        title: `第 ${i + 1} 集`,
        desc: descPool[i % descPool.length],
      })),
    [count]
  );

  if (count === 0) return null;

  const current = episodes[selected] ?? episodes[0];

  return (
    <section aria-labelledby="episode-title" className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <h2
        id="episode-title"
        className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950"
      >
        <i className="ri-play-list-line text-xl text-primary-500" aria-hidden="true" />
        剧集列表
        <span className="ml-1 text-sm font-normal text-foreground-500">共 {count} 集</span>
      </h2>

      <div className="mt-4 grid grid-cols-4 gap-2 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-10">
        {episodes.map((ep, i) => (
          <button
            key={ep.index}
            type="button"
            onClick={() => setSelected(i)}
            className={`rounded-md border py-2 text-xs font-medium transition-colors ${
              i === selected
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-300 bg-background-100 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {ep.index}
          </button>
        ))}
      </div>

      <div className="mt-5 rounded-lg bg-secondary-50 p-4">
        <p className="font-heading text-sm font-bold text-foreground-950">{current.title} · 简介</p>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{current.desc}</p>
      </div>
    </section>
  );
}